import React from 'react'
import './style.sass'

const AppListEmptyState = () => {
  return (
    <div className="app-list-empty-state-container">
      <div className="wrapper">
        <div className="card-container">
          <i className="fa fa-rocket"></i><br />
          <h5>No applications yet!</h5>
          <p>How odd! We cannot find any applications...</p>
        </div>
      </div>
    </div>
  )
}

export default AppListEmptyState
